import {
  Box,
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { ErrorTypography } from "components/ErrorTypography";
import { MFA_CODE_EXPIRY_MINUTES, MFA_CODE_LENGTH } from "constants/index";

interface Props {
  destination: string;
  code: string;
  onCodeChange: (value: string) => void;
  onVerify: VoidFunction;
  onBackToLogin: VoidFunction;
  loading: boolean;
  error: string | null;
}

export function MFAChallenge(props: Props) {
  const {
    destination,
    code,
    onCodeChange,
    onVerify,
    onBackToLogin,
    loading,
    error,
  } = props;

  const canSubmit = code.length === MFA_CODE_LENGTH && !loading;

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && canSubmit) {
      onVerify();
    }
  };

  return (
    <Box>
      <Typography textAlign="center" variant="h4" fontWeight="bold">
        Enter Verification Code
      </Typography>
      <Typography textAlign="center" color="text.secondary" mt="0.5rem">
        A code was sent to {destination}
      </Typography>
      <Stack my="2rem" spacing={2}>
        <TextField
          label="Verification Code"
          variant="outlined"
          value={code}
          onChange={(e) => onCodeChange(e.target.value)}
          onKeyDown={handleKeyDown}
          inputProps={{
            maxLength: MFA_CODE_LENGTH,
            style: {
              textAlign: "center",
              letterSpacing: "0.5rem",
              fontFamily: "monospace",
            },
          }}
          helperText={`This code expires in ${MFA_CODE_EXPIRY_MINUTES} minutes.`}
          autoFocus
        />
        <ErrorTypography error={error} />
        {loading ? (
          <Stack alignItems="center">
            <CircularProgress />
          </Stack>
        ) : (
          <Button variant="contained" onClick={onVerify} disabled={!canSubmit}>
            Verify
          </Button>
        )}
        <Button variant="text" onClick={onBackToLogin}>
          Back to Login
        </Button>
      </Stack>
    </Box>
  );
}
